import { Component } from '@angular/core';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'housemates';

  isAuthenticated:boolean = false;
  
  constructor(
    private authService: AuthService
  ) {}

  ngAfterViewInit(): void {
    try {
      // Handle the preloader
      const preloader = document.getElementById("preloader") as HTMLElement;

      if (preloader) {
        setTimeout(() => {
          preloader.classList.add("fadex");
          // preloader.hide();
          this.checkAuthenticationStatus();
        }, 3000);
      }
    } catch (error) {
      // local
    }
  }

  private checkAuthenticationStatus() {
    this.authService.isAuthenticated.subscribe(authenticated => {
      this.isAuthenticated = authenticated;
    });
  }

}
